<script>
    import { onDestroy } from 'svelte';

    import {snapLogs} from './stores.js';
    import {currentSnapImage, getSnapImage} from './stores';

    let currentImage = "";
    let currentPreviewImage = "";

    function getImageFromServer(id){
        let newPath = `https://drawboard.cafe/getSnapshot?${id}`;
        currentImage = newPath;
    }

    function onHover(id){
        let newPath = `https://drawboard.cafe/getSnapshot?${id}-THM`;
        currentPreviewImage = newPath;
        imagePreviewDisplayType = "block";
    }

    function onLeave(){
        imagePreviewDisplayType = "none";
    }

    function moveMousePosition(event){
        let x = (event.clientX - 250);
        let y = event.clientY;

        imagePreviewThing.style.left = `${x}px`;
        imagePreviewThing.style.top = `${y}px`;
    }

    let imagePreviewThing;
    let imagePreviewDisplayType = "none";

</script>



<div class="contentBox" on:mousemove={moveMousePosition}>

    <h1>Snapshots</h1>

    <p>
        This place saves it's own canvas every 30 minutes after someone scribbles down anything.
        Feel free to let your inner internet archaeologist out and browse the evolution of this place
    </p>

    <div class="galleryHolder">
        <div class="galleryViewer">

            {#if currentImage == ""}
                <img class="snapshotImage" src="https://drawboardcafe.neocities.org/Question.png">
            {:else}
                <img class="snapshotImage" src="{currentImage}">
            {/if}
            

            <div class="snapshotList">

                {#each $snapLogs as log}
                    <button on:mouseenter={() => {onHover(log.id)}} on:mouseleave={onLeave} on:click={() => {getImageFromServer(log.id)}}>{log.date}</button>
                {/each}

            </div>
        </div> 
    </div>

    <!-- image preview thing! -->
    <img bind:this={imagePreviewThing} style="display: {imagePreviewDisplayType};" class="imgPreviewPopup" src="{currentPreviewImage}" alt="">


</div>


<style>

    .imgPreviewPopup{
        display: none;
        position: fixed;
        left: 0px;
        top: 0px;
    }

    .contentBox{
        padding: 25px;
    }

    .galleryViewer{
        display: flex;
    }

    .snapshotImage{
        width: 70%;
        height: 20%;
        border: 1px solid black;
    }

    .snapshotList{
        width: 25%;
        margin-left: 5px;
        height: 500px;
        overflow: auto;
    }

    .snapshotList button{
        width: 100%;
        margin: 0px;
        margin-bottom: 3px;
    }
</style>